export default __webpack_public_path__ + "static/media/logo.1538a4a1.png";